import { TrendingUp, Award } from "lucide-react";
import useScrollReveal from "@/hooks/useScrollReveal";

const KarriereSection = () => {
  const sectionRef = useScrollReveal();

  return (
    <section id="karriere" data-testid="karriere-section" className="py-24 md:py-32 bg-emerald-600 text-white relative overflow-hidden" ref={sectionRef}>
      <TrendingUp className="absolute -top-20 -right-20 w-96 h-96 text-white/10 rotate-12" />
      <div className="container-custom relative z-10">
        <div className="lg:grid lg:grid-cols-2 lg:gap-20 items-center">
          <div className="reveal">
            <h2 className="text-4xl lg:text-5xl font-bold mb-8 leading-[1.1] font-[Outfit]">
              Thermomix® Karriere in Krefeld <br/><span className="text-emerald-200 italic">– dein Weg zum 0 € TM7.</span>
            </h2>
            <p className="text-xl text-emerald-50 mb-12 leading-relaxed">
              Werde Teil meines Teams in Krefeld. Wir suchen leidenschaftliche Menschen, die ihre 
              Begeisterung teilen wollen. Du investierst kein Geld, sondern nur deine Zeit und Energie.
            </p>
            <div className="space-y-8 mb-12">
              <div className="flex gap-4">
                <div className="w-12 h-12 bg-white/20 rounded-2xl flex items-center justify-center font-bold backdrop-blur-sm">1</div>
                <div>
                  <h4 className="font-bold text-lg">Kein Startkapital</h4>
                  <p className="text-emerald-100 text-sm">Du bekommst dein Leihgerät und alle Schulungen kostenlos gestellt.</p>
                </div>
              </div>
              <div className="flex gap-4">
                <div className="w-12 h-12 bg-white/20 rounded-2xl flex items-center justify-center font-bold backdrop-blur-sm">2</div>
                <div>
                  <h4 className="font-bold text-lg">4 Verkäufe = Dein TM7</h4>
                  <p className="text-emerald-100 text-sm">Vermittle nur 4 Geräte in deiner Startphase und der TM7 gehört dir – geschenkt!</p>
                </div>
              </div>
            </div>
            <a href="#kontakt" className="inline-flex px-10 py-5 bg-white text-emerald-600 rounded-full font-bold text-lg hover:bg-slate-100 transition shadow-2xl">
              Jetzt unverbindlich anfragen
            </a>
          </div>
          <div className="mt-16 lg:mt-0 reveal reveal-delay-1">
            <div className="glass rounded-[2rem] p-10 shadow-2xl bg-slate-900/40 border border-white/20">
              <Award className="w-16 h-16 text-yellow-400 mb-8" />
              <h3 className="text-3xl font-bold mb-6 font-[Outfit]">Dein Team in Krefeld</h3>
              <p className="text-emerald-100 mb-8 leading-relaxed italic">
                "Der Einstieg als Repräsentantin war die beste Entscheidung meines Jahres. 
                Ich habe nicht nur einen kostenlosen Thermomix® verdient, sondern eine tolle 
                Community und finanzielle Freiheit gewonnen. Ich begleite dich bei jedem Schritt!"
              </p>
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 rounded-full bg-emerald-500 border-2 border-white shadow-sm flex items-center justify-center font-bold text-xs text-white">JL</div>
                <div>
                  <p className="font-bold">Jennifer Laak</p>
                  <p className="text-xs text-emerald-400 font-bold uppercase tracking-widest">Deine Mentorin</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default KarriereSection;
